import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const Field = ({ label, value, xs = 12, md = 2 }) => (
  <Col xs={xs} md={md} className="mb-3">
    <div className="d-flex flex-column mb-3">
      <span className="type">{label}</span>
      <span className={`answer ${!value ? 'text-grey' : ''}`}>{value || 'No Aplica'}</span>
    </div>
  </Col>
);

const SelectionProcessInfo = ({ selectionProcess }) => {
  const {
    description,
    desiredKnowledge,
    jobDescription,
    jobManagement,
    jobTitle,
    selectionProcessStagesAttributes,
    startDate,
    optionalKnowledge,
    parsedSuggestedSalary,
    translatedExpertiseLevel,
    translatedProcessType,
    translatedRemote,
    translatedStatus,
    translatedWorkSchedule,
    vacancies
  } = selectionProcess || {};

  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Body>
            <Row>
              <Field label="Estado:" value={translatedStatus} />
              <Field label="Fecha de Inicio:" value={startDate} />
              <Field label="Cargo:" value={jobTitle?.label} />
              <Field label="Área:" value={jobManagement?.label} />
              <Field label="Vacantes:" value={vacancies != null ? String(vacancies) : ''} />
              <Field label="Tipo de Jornada:" value={translatedWorkSchedule} />
            </Row>

            <Row>
              <Field label="Salario Sugerido:" value={parsedSuggestedSalary} />
              <Field label="Modalidad:" value={translatedRemote} />
              <Field label="Nivel de Experiencia:" value={translatedExpertiseLevel} />
              <Field label="Tipo de proceso:" value={translatedProcessType} />
              <Field
                label="N° de Etapas:"
                value={
                  Array.isArray(selectionProcessStagesAttributes)
                    ? String(selectionProcessStagesAttributes.length)
                    : '0'
                }
              />
            </Row>

            <Row>
              <Field label="Descripción:" value={description} md="12" />
            </Row>

            <Row>
              <Field label="Funcionalidad del cargo:" value={jobDescription} md="12" />
            </Row>

            <Row>
              <Field label="Conocimientos deseables:" value={desiredKnowledge} md="12" />
            </Row>

            <Row>
              <Field
                label="Conocimientos Opcionales:"
                value={optionalKnowledge || 'No Aplica'}
                md="12"
              />
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SelectionProcessInfo;
